import * as types from './types';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.CREDITCARDPAYMENT_REPORT_LOAD:
      return { ...state, reportLoading: action.payload };
    case types.GET_CREDITCARDPAYMENT_REPORT:
      return { ...state, reports: action.payload.data.Data };
    case types.CLEAR_REPORT_DATA:
      return { ...state, reports: [], studentReport: [] };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/creditcardpayment/state/reducer.js